module.exports = __webpack_public_path__ + "img/project1.16bd0610.jpg";